export default __webpack_public_path__ + "static/media/sample_dash.8efd617d.png";